import { render } from "./FiltersSidebar.vue?vue&type=template&id=4c1f44f5&scoped=true"
import script from "./FiltersSidebar.vue?vue&type=script&lang=ts"
export * from "./FiltersSidebar.vue?vue&type=script&lang=ts"

import "./FiltersSidebar.vue?vue&type=style&index=0&id=4c1f44f5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c1f44f5"

export default script